import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { Lock, ArrowRight, ShieldCheck } from 'lucide-react';

export default function CambiarContrasena() {
  const { changePassword, user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error('Completa todos los campos');
      return;
    }

    if (newPassword.length < 4) {
      toast.error('El nuevo password debe tener al menos 4 caracteres');
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('Los passwords no coinciden');
      return;
    }

    setLoading(true);
    try {
      await changePassword(currentPassword, newPassword);
      toast.success('Password actualizado correctamente');
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Error al cambiar password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB] p-4" data-testid="cambiar-contrasena-page">
      <div className="w-full max-w-md">
        <div className="mac-card p-8">
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 rounded-md bg-[#0082D2]/10 flex items-center justify-center mb-4">
              <ShieldCheck size={32} className="text-[#0082D2]" />
            </div>
            <h1 className="text-xl font-bold text-[#0A0A0A]" style={{ fontFamily: 'Outfit, sans-serif' }}>Crear tu Password</h1>
            <p className="text-[13px] text-gray-500 mt-2 text-center">
              Bienvenido <strong>{user?.nombre}</strong>. Por seguridad, crea un password personal para tu cuenta.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="form-label">Password actual</label>
              <div className="relative">
                <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  className="form-input pl-11"
                  placeholder="Password que te dieron"
                  data-testid="current-password"
                />
              </div>
            </div>

            <div>
              <label className="form-label">Nuevo password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="form-input pl-11"
                  placeholder="Tu nuevo password"
                  data-testid="new-password"
                />
              </div>
            </div>

            <div>
              <label className="form-label">Confirmar nuevo password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="form-input pl-11"
                  placeholder="Repetir nuevo password"
                  data-testid="confirm-password"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex items-center justify-center gap-2 py-3"
              data-testid="change-password-submit"
            >
              {loading ? 'Guardando...' : (
                <>
                  Guardar Password
                  <ArrowRight size={16} />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
